const endpoint = import.meta.env.VITE_API_HOST
export default endpoint
